import { motion } from 'motion/react'
import { ComponentRenderer } from '../ComponentRenderer'
import { Tile } from '../Tile'
import { useMemo } from 'react'
import { useGetAppPage } from '../useGetAppPage'
import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { ErrorBoundary } from 'react-error-boundary'
import { Button } from '@/components/shadcn/button'
import { IconWarningOutline } from '@/components/icons'
import { QueryErrorBoundary } from '../../QueryErrorBoundary'

interface TileGridProps {
  isConfiguringLayout: boolean
}

export function TileGrid({ isConfiguringLayout }: TileGridProps) {
  const {
    data: {
      containers,
      gridLayout: { cols, rows },
    },
  } = useGetAppPage()

  const gridContainerStyles = useMemo(
    () => ({
      gridTemplateRows: `repeat(${rows}, minmax(0, 320px))`,
      gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
    }),
    [cols, rows]
  )

  return (
    <motion.div layout style={gridContainerStyles} className="grid w-full gap-5 overflow-visible bg-background py-5">
      {containers.map((container) => {
        const {
          component: { type, id },
          ...rest
        } = container
        return (
          <QueryErrorBoundary
            errorMessage={
              <span>
                Failed to fetch data for <span className="font-semibold italic">"{id}"</span>
              </span>
            }
          >
            <Tile key={rest.id} container={rest} isConfiguringLayout={isConfiguringLayout}>
              <ComponentRenderer type={type} id={id} />
            </Tile>
          </QueryErrorBoundary>
        )
      })}
    </motion.div>
  )
}
